import React from "react";
import styled from "styled-components";
import { Theme } from "../../../common/themes/theme";
import Eyebrow from "../../../common/components/eyebrow/Eyebrow";
import H2 from "../../../common/components/text/H2";
import Description from "../../../common/components/text/Description";
import {
  HeaderLeft,
  HeadingBlock,
} from "../../../common/components/layout/HeadingBlock";
import { Icon } from "@iconify/react";
import PrimaryButton from "../../../common/components/button/PrimaryButton";

const { color, font, border } = Theme;

const Wrapper = styled.section`
  background: ${color.background.light};
  font-family: ${font.fontFamily.sans};
  display: flex;
  flex-direction: column;
  border-top: 1px solid ${color.border.light};
`;

const Top = styled.div`
  padding: 64px 50px 50px;
  background: ${color.surface.light};
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 32px;

  @media (max-width: ${Theme.breakpoints.TABLET_SMALL}px) {
    flex-direction: column;
    align-items: flex-start;
    padding: 48px 20px 40px;
  }
`;
const MapOuter = styled.div`
  padding: 0px 50px 50px;
  background-color: ${color.default.white};

  @media (max-width: ${Theme.breakpoints.TABLET_SMALL}px) {
    padding: 0 20px 40px;
  }
`;

const MapWrap = styled.div`
  position: relative;
  width: 100%;
  height: 620px;
  overflow: hidden;

  @media (max-width: ${Theme.breakpoints.TABLET_SMALL}px) {
    height: 450px;
  }
`;

const MapIframe = styled.iframe`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border: none;
  display: block;
  filter: grayscale(15%) contrast(1.02);
`;

const MapOverlayBadge = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  background: ${color.surface.light};
  border: 1px solid ${color.border.light};
  border-left: 3px solid ${color.text.primary};
  border-radius: ${border.borderRadius.sm};
  padding: 10px 14px;
  z-index: 2;
  pointer-events: none;
`;

const BadgeTitle = styled.p`
  font-family: ${font.fontFamily.heading[0]}, sans-serif;
  font-size: ${font.fontSize.md};
  font-weight: ${font.fontWeight.bold};
  text-transform: uppercase;
  color: ${color.text.heading};
  margin: 0 0 2px;
  letter-spacing: 0.02em;
`;

const BadgeSub = styled.p`
  font-size: ${font.fontSize.xs};
  color: ${color.text.secondary};
  margin: 0;
  letter-spacing: 0.04em;
`;

function VisitUsSection() {
  return (
    <Wrapper>
      <Top>
        <HeaderLeft>
          <HeadingBlock>
            <Eyebrow text="Find Us" />
            <H2>
              <span>Visit</span> Us
            </H2>
            <Description>
              Our team is available to walk you through our capabilities and
              discuss your project requirements.
            </Description>
          </HeadingBlock>
        </HeaderLeft>

        <PrimaryButton
          as="a"
          href="https://maps.app.goo.gl/HT5DiCd4ShcebcMj9"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Icon icon="ic:outline-map" height="18px" />
          Get Directions
        </PrimaryButton>
      </Top>
      <MapOuter>
        <MapWrap>
          <MapIframe
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d5898421.3514599595!2d82.09188650580238!3d28.4024564552156!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47a64d39ee6cf841%3A0x90dce4283d6ddd16!2sAURA%20Metal%20Fab%20Nepal%20Pvt.%20Ltd.!5e1!3m2!1sen!2snp!4v1782368691431!5m2!1sen!2snp"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Aura Metals location — Imadol Mahalaxmi-02, Nepal"
          />
          <MapOverlayBadge>
            <BadgeTitle>Aura Metals</BadgeTitle>
            <BadgeSub>Imadol Mahalaxmi-02, Nepal</BadgeSub>
          </MapOverlayBadge>
        </MapWrap>
      </MapOuter>
    </Wrapper>
  );
}

export default VisitUsSection;
